import styles from './multi-select.module.css';
import { cn } from '../../../../utils';
import { Icon } from '../../../symbols';
import { BaseOption, RenderItemProps } from './types';

export function SelectedItem<Option extends BaseOption>({
  label,
  onRemove,
  ...props
}: RenderItemProps<Option>) {
  return (
    <button {...props} onClick={onRemove} className={cn(styles.selected)}>
      {label} <Icon name="cross-small" />
    </button>
  );
}

export function defaultRenderSelected<Option extends BaseOption>(
  props: RenderItemProps<Option>,
) {
  return <SelectedItem {...props} />;
}
